var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5647 13.0746V14.8079H30.4633V28.1976C30.4633 31.5368 29.1025 33.7452 26.8544 34.1841V14.8079V13.0746V11.1847C26.8544 4.09658 18.6965 0.316713 18.3487 0.158358L18.0008 0L17.653 0.158358C17.5665 0.197946 15.5168 1.13603 13.4468 2.92958C10.6337 5.36687 9.14732 8.2207 9.14732 11.1847V13.0746V14.8079V34.1824C8.25823 34.0068 7.49131 33.5489 6.89576 32.8312C6.00837 31.7623 5.54008 30.1598 5.54008 28.1976V14.8079H7.43701V13.0746H3.82977V28.1976C3.82977 30.5746 4.43721 32.5627 5.58759 33.9483C6.68537 35.2719 8.25314 36 10.0008 36C12.8479 36 16.1735 33.9569 16.1735 28.1976V14.8079H19.8282V13.0746H14.4615V14.8079H14.4632V28.1976C14.4632 31.5368 13.1024 33.7452 10.8542 34.1841V11.183C10.8542 5.97447 16.5213 2.68343 17.9991 1.91403C19.4787 2.68515 25.144 5.97619 25.144 11.183V34.1841C22.8976 33.7452 21.5351 31.5368 21.5351 28.1976V14.8079V13.0746H19.8248V28.1976C19.8248 33.9569 23.1504 36 25.9975 36C28.8446 36 32.1702 33.9569 32.1702 28.1976V13.0746H28.5613H28.5647Z",
    fill: "#18181A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b4a0000048617c61f0defd3e7fdfcf72.svg";
export { ForwardRef as ReactComponent };